import "core-js/modules/es.array.push.js";
import nav from '@/utils/nav-router';
export default {
  name: 'LNav',
  components: {},
  data() {
    return {
      nav,
      defaultActive: '/baas'
    };
  },
  computed: {},
  watch: {
    '$route': {
      handler(n) {
        this.defaultActive = n.path;
      }
    }
  },
  created() {
    this.defaultActive = this.$route.path;
  },
  mounted() {},
  methods: {
    handleMenuSelect(index) {
      if (index) {
        index.indexOf('http') === -1 ? this.$router.push(index) : window.open(index);
      }
    }
  }
};